import { Flex, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import { CalendarPage } from '../../ui';
import type { IEvent } from '../../../lib';

interface IEventDatesProps {
	event: IEvent;
	isSameDayEvent: boolean;
	isListItem: boolean;
	eventPopoverColor: string;
	eventTooltipTextColor: string;
}

export const EventDates = ({
	event,
	isListItem,
	isSameDayEvent,
	eventPopoverColor,
	eventTooltipTextColor,
}: IEventDatesProps) => (
	<Flex
		flexDirection={isListItem ? 'column' : 'row'}
		className='event-dates'
		gap={0}
		alignItems='center'
		px={3.5}
		pt={isListItem ? 2 : 4}
		pb={isListItem ? 2 : 0}
	>
		<CalendarPage
			bg={eventTooltipTextColor}
			color={eventPopoverColor}
			day={format(event.start, 'dd')}
			month={format(event.start, 'MMM')}
		/>
		{!isSameDayEvent && (
			<>
				<Text fontWeight='900' className='margin-0' color={eventTooltipTextColor}>
					{isListItem ? '|' : '-'}
				</Text>
				<CalendarPage
					bg={eventTooltipTextColor}
					color={eventPopoverColor}
					day={format(event.end, 'dd')}
					month={format(event.end, 'MMM')}
				/>
			</>
		)}
	</Flex>
);
